import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Switch } from './ui/switch';
import { getConsent, saveConsent, OPEN_SETTINGS_EVENT } from '../lib/consent';

const btn = 'flex-1 sm:flex-none px-5 py-2.5 rounded-full text-sm font-semibold border transition-colors';
const btnMain = `${btn} border-[hsl(207,90%,54%)] bg-[hsl(207,90%,54%)] text-white hover:bg-[hsl(207,90%,46%)]`;
const btnAlt = `${btn} border-gray-300 bg-white text-gray-900 hover:bg-gray-50`;

const Settings = ({ ads, setAds }) => (
  <div className="mt-4 space-y-3" data-testid="cookie-settings-panel">
    <div className="flex items-start justify-between gap-4 rounded-xl border border-gray-200 p-3">
      <div>
        <p className="text-sm font-semibold text-gray-900">Strictement nécessaires</p>
        <p className="text-xs text-gray-600">Fonctionnement du site, mémorisation de vos choix et connexion à l'espace d'administration. Toujours actifs.</p>
      </div>
      <Switch checked disabled aria-label="Cookies strictement nécessaires" data-testid="cookie-necessary-switch" />
    </div>
    <div className="flex items-start justify-between gap-4 rounded-xl border border-gray-200 p-3">
      <div>
        <p className="text-sm font-semibold text-gray-900">Mesure publicitaire (Meta Pixel)</p>
        <p className="text-xs text-gray-600">Mesure l'efficacité de nos publicités Facebook et Instagram. Dépose des cookies Meta (_fbp).</p>
      </div>
      <Switch checked={ads} onCheckedChange={setAds} aria-label="Mesure publicitaire Meta" data-testid="cookie-ads-switch" />
    </div>
  </div>
);

export const CookieBanner = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(() => !getConsent());
  const [custom, setCustom] = useState(false);
  const [ads, setAds] = useState(false);

  useEffect(() => {
    const show = () => { setAds(getConsent()?.ads === true); setCustom(true); setOpen(true); };
    window.addEventListener(OPEN_SETTINGS_EVENT, show);
    return () => window.removeEventListener(OPEN_SETTINGS_EVENT, show);
  }, []);

  if (!open || pathname.startsWith('/admin')) return null;
  const decide = (value) => { saveConsent(value); setOpen(false); setCustom(false); };

  return (
    <div role="dialog" aria-modal="false" aria-labelledby="cookie-title" data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-5">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-200 p-5 max-h-[85vh] overflow-y-auto">
        <p id="cookie-title" className="flex items-center gap-2 font-bold text-gray-900"><Cookie className="w-5 h-5 text-[hsl(207,90%,54%)]" />Vos choix concernant les cookies</p>
        <p className="mt-2 text-sm text-gray-600 leading-relaxed">
          Avec votre accord, nous utilisons le pixel Meta pour mesurer l'efficacité de nos publicités. Les cookies strictement nécessaires au fonctionnement du site ne nécessitent pas votre accord.
          Vous pouvez modifier votre choix à tout moment via « Gestion des cookies » en bas de page. <Link to="/politique-de-confidentialite" className="underline text-[hsl(207,90%,44%)]" data-testid="cookie-privacy-link">En savoir plus</Link>
        </p>
        {custom && <Settings ads={ads} setAds={setAds} />}
        <div className="mt-4 flex flex-wrap gap-2 justify-end">
          <button type="button" className={btnMain} onClick={() => decide(false)} data-testid="cookie-reject-all">Tout refuser</button>
          {custom
            ? <button type="button" className={btnAlt} onClick={() => decide(ads)} data-testid="cookie-save-choices">Enregistrer mes choix</button>
            : <button type="button" className={btnAlt} onClick={() => { setAds(false); setCustom(true); }} data-testid="cookie-customize">Personnaliser</button>}
          <button type="button" className={btnMain} onClick={() => decide(true)} data-testid="cookie-accept-all">Tout accepter</button>
        </div>
      </div>
    </div>
  );
};
